import _app from "../../../views/_app.tsx";
import _error from "../../../views/_error.tsx";

/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { viewManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
const manifest = {
  "_app": _app,
  "_error": _error,
  "page": dynamic(() => import("../../../views/page.tsx"), "views/page.tsx"),
  "single-film": dynamic(() => import("../../../views/single-film.tsx"), "views/single-film.tsx"),
  "single-news": dynamic(() => import("../../../views/single-news.tsx"), "views/single-news.tsx"),
  "single-programs": dynamic(() => import("../../../views/single-programs.tsx"), "views/single-programs.tsx"),
  "template-holding-page": dynamic(
    () => import("../../../views/template-holding-page.tsx"),
    "views/template-holding-page.tsx",
  ),
};

viewManifestReader.set(manifest);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
